<script setup>
import { HrIcon } from '../primitives';

/**
 * Drag grip for a HrSortableList row — a grab-cursor icon marking where a drag starts.
 * Place it inside a sortable row (e.g. in HrListItem's `#leading` slot); it carries the class
 * HrSortableList's default `handleSelector` matches, so no magic string leaks to the consumer.
 *
 * @status recommended
 * @group lists-tables
 * @useWhen Marking the draggable grip on a row inside HrSortableList
 * @a11y Decorative and pointer-only (`aria-hidden`) — dragging has no keyboard path, so the row's
 *   accessible reorder affordance (e.g. Move up / Move down in its menu) must live elsewhere. On
 *   compact / mobile layouts, hide the handle and rely on that menu path.
 */
defineOptions({ name: 'HrDragHandle' });

defineProps({
  /**
   * Icon size.
   * @values xxs, xs, sm, md, lg, xl
   */
  size: {
    type: String,
    default: 'sm',
  },
});
</script>

<template>
  <hr-icon
    name="drag_indicator"
    :size="size"
    class="hr-sortable-list__handle"
    aria-hidden="true"
  />
</template>
